import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { GreenTickCircle } from "../../assets/svgs";
import "./styles.scss";

const RequiredDocumentsCard = ({ heading, noteQuestion, noteAnswer }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const routeName = location.pathname.split("/")[1];

  return (
    <div className="required-documents-card-container">
      <p className="required-docs-heading">
        {t(routeName ? `${routeName}.${heading}` : `${heading}`)}
      </p>
      <div className="required-docs-list">
        {[1].map(() => (
          <div className="required-docs-item">
            <img
              src={GreenTickCircle}
              alt="check"
              className="required-docs-icon"
            />
            <p className="required-docs-name">Payroll Certificate</p>
          </div>
        ))}
      </div>
      <p className="required-docs-note-question">
        {t(routeName ? `${routeName}.${noteQuestion}` : `${noteQuestion}`)}
      </p>
      <p className="required-docs-note-answer">
        {t(routeName ? `${routeName}.${noteAnswer}` : `${noteAnswer}`)}
      </p>
    </div>
  );
};

export default RequiredDocumentsCard;
